export const BAZAARVOICE_REVIEW_SECTION_ID = 'bazaarvoice-reviews';
